module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/service-management/service-management.component.scss
// module id = ./src/app/Dashboard/DashboardPages/service-management/service-management.component.scss
// module chunks = main